module.exports = __webpack_public_path__ + "img/pic10.4aa42ef1.jpg";